import Model from "@/lib/model/model";
import request from "@/lib/request/request";

export default class Log extends Model {
  static sendLog(data: any) {
    return request.post("aiExam/common/log", data).then(resp => {
      return resp;
    });
  }
}
